import title from './title';
import vehicle from './vehicle';
import vehicleViews from './vehicleViews';

const root = {
	title,
	vehicle,
	vehicleViews
};

export default root;
